export default function PHP_get_client_version() {
  return (
    <div>
      <h1>PHP_get_client_version</h1>
    </div>
  );
}
